import { ReleaseNotesModal } from '@app/components/Organisms/Modals/ReleaseNotesModal/ReleaseNotesModal'
import { SubmitFeedbackModal } from '@app/components/Organisms/Modals/SubmitFeedbackModal/SubmitFeedbackModal'
import { TsnCsModal } from '@app/components/Organisms/Modals/TsnCsModal/TsnCsModal'
import {
  showClientTsnCsModalAtom,
  showFeedbackModalAtom,
  showReleaseDialogAtom,
} from '@app/state/modalAtom'
import { clientTermsConditionsAtom } from '@app/state/clientsAtom'
import { useAtom, useAtomValue } from 'jotai'
import { createPortal } from 'react-dom'
import { useTermsAndConditions } from '@app/Auth/hooks/useTermsAndConditions'
import { userAtom } from '@app/hooks/useUserProfile'
import { useEffect } from 'react'
import { DeleteUserConfirmModal } from '@app/modules/Admin/components/Admin.DeleteUserConfirmModal'

export const ModalManager = () => {
  const [showReleaseDialog, setShowReleaseDialog] = useAtom(showReleaseDialogAtom)
  const [showFeedbackModal, setShowFeedbackModal] = useAtom(showFeedbackModalAtom)
  const [clientTermsConditions] = useAtom(clientTermsConditionsAtom)
  const [showClientTsnCsModal, setShowClientTsnCsModal] = useAtom(showClientTsnCsModalAtom)
  const { mutate: acceptTermsAndConditionsMutation, isSuccess: termsAccepted } =
    useTermsAndConditions()
  const { data: userProfile, refetch: refetchUserProfile } = useAtomValue(userAtom)

  useEffect(() => {
    if (termsAccepted) {
      refetchUserProfile()
    }
  }, [termsAccepted, setShowClientTsnCsModal, refetchUserProfile])

  return (
    <>
      {/* TODO: Add back in when we have a way to accept TsnCs */}
      {/* {showMainTsnCs &&
        createPortal(
          <TsnCsModal
            content={settings.tsncs_html}
            handleAcceptTsnCs={() => {
              localStorage.setItem('tsncs_accepted', 'true')
            }}
          />,
          document.body,
        )} */}
      {showClientTsnCsModal &&
        clientTermsConditions &&
        createPortal(
          <TsnCsModal
            content={clientTermsConditions ?? ''}
            handleAcceptTsnCs={() => {
              acceptTermsAndConditionsMutation({
                user_info: {
                  user_uuid: userProfile?.user_uuid ?? '',
                  client_name: userProfile?.client_name ?? '',
                },
              })
            }}
            showClientLogo
          />,
          document.body,
        )}
      {showReleaseDialog &&
        createPortal(
          <ReleaseNotesModal
            open={showReleaseDialog}
            handleClose={() => {
              setShowReleaseDialog(false)
              // your logic
            }}
          />,
          document.body,
        )}
      {createPortal(
        <SubmitFeedbackModal
          open={showFeedbackModal}
          handleClose={() => setShowFeedbackModal(false)}
        />,
        document.body,
      )}

      {createPortal(<DeleteUserConfirmModal />, document.body)}
    </>
  )
}
